import LayoutMain    from '@/layouts/_layout_main.vue'
import LayoutEmpty   from '@/layouts/_layout_empty.vue'
import LayoutDefault from '@/layouts/_layout_default.vue'
import _config       from './plugins/config'

import store   from './store'  // 스토어 인스턴스 생성

const routes = [
  {
    path: _config.LOGOUT_PATH,
    meta: { noAuth: true } ,
    beforeEnter(to, from, next) {
      store.dispatch("session/LOGGED_OUT")
      next('/')
    },
  },
  {
    path: '/main', component: LayoutMain,
    children: [
      { path: 'main', component: () => import(/* webpackChunkName:"main" */ './pages/main/main.vue'), meta: { noAuth: true } },
    ]
  },
  {
    // path: '/main', component: LayoutEmpty,
    // path: '/main', component: LayoutMain,
    path: '/viainfo/:data', component: LayoutDefault,
    children: [
      { path: '', component: () => import(/* webpackChunkName:"viainfo" */ './pages/main/viainfo.vue'), meta: { smenu: 'viainfo', noAuth: true } },
    ]
  },
  {
    path: '/', component: LayoutDefault,
    children: [
      // { path: '', name: 'home', component: Home, meta: { noAuth: false } },
      { path: '', redirect: '/main/main' },

      // 로그인
      { meta: { smenu: 'member', noAuth: true }, path: _config.LOGIN_PATH     , component: () => import(/* webpackChunkName:"member" */ './pages/member/login')},
      { meta: { smenu: 'member', noAuth: true }, path: 'member/join'          , component: () => import(/* webpackChunkName:"member" */ './pages/member/join')},
      { meta: { smenu: 'member', noAuth: true }, path: 'member/join_form'     , component: () => import(/* webpackChunkName:"member" */ './pages/member/join_form')},

      { meta: { smenu: 'member', noAuth: true }, path: 'member/info/customerpersonal'   , component: () => import(/* webpackChunkName:"info" */ './pages/member/info')},
      { meta: { smenu: 'member', noAuth: true }, path: 'member/info/customerclause'     , component: () => import(/* webpackChunkName:"info" */ './pages/member/info')},
      { meta: { smenu: 'member', noAuth: true }, path: 'member/info/customersite'       , component: () => import(/* webpackChunkName:"info" */ './pages/member/info')},
      { meta: { smenu: 'member', noAuth: true }, path: 'member/info/customeremail'      , component: () => import(/* webpackChunkName:"info" */ './pages/member/info')},

      // 메인
      { path: 'main/index'               ,  component: () => import(/* webpackChunkName:"main" */ './pages/main/index.vue') },

      // 경유증표 안내
      { meta: { smenu: 'info'   }, path: 'info/info_kind'       ,  component: () => import(/* webpackChunkName:"info"    */ './pages/info/info_kind.vue') },
      { meta: { smenu: 'info'   }, path: 'info/info_law'        ,  component: () => import(/* webpackChunkName:"info"    */ './pages/info/info_law.vue') },
      { meta: { smenu: 'info'   }, path: 'board/faq'            ,  component: () => import(/* webpackChunkName:"info"    */ './pages/board/faq.vue') },

      // 공지사항
      { meta: { smenu: 'board'   }, path: 'board/board_list'       ,  component: () => import(/* webpackChunkName:"board"    */ './pages/board/board_list.vue') },
      { meta: { smenu: 'board'   }, path: 'board/board_view'       ,  component: () => import(/* webpackChunkName:"board"    */ './pages/board/board_view.vue') },
      { meta: { smenu: 'board'   }, path: 'board/board_form'       ,  component: () => import(/* webpackChunkName:"board"    */ './pages/board/board_form.vue') },

      // 증표사용 입력 조회
      { meta: { smenu: 'use' }, path: 'use/use_via'    ,  component: () => import(/* webpackChunkName:"use" */ './pages/use/use_via.vue') },
      { meta: { smenu: 'use' }, path: 'use/edit_via'   ,  component: () => import(/* webpackChunkName:"use" */ './pages/use/edit_via.vue') },

      // 신고신청
      { meta: { smenu: 'apply' }, path: 'apply/viafree_req'       ,  component: () => import(/* webpackChunkName:"apply" */ './pages/apply/viafree_req.vue') },
      { meta: { smenu: 'apply' }, path: 'apply/viafree_choffice'  ,  component: () => import(/* webpackChunkName:"apply" */ './pages/apply/viafree_choffice.vue') },
      { meta: { smenu: 'apply' }, path: 'apply/viafree_bokdari'   ,  component: () => import(/* webpackChunkName:"apply" */ './pages/apply/viafree_bokdari.vue') },
      { meta: { smenu: 'apply' }, path: 'apply/refund'            ,  component: () => import(/* webpackChunkName:"apply" */ './pages/apply/refund.vue') },
      { meta: { smenu: 'apply' }, path: 'apply/wrong_change_req'  ,  component: () => import(/* webpackChunkName:"apply" */ './pages/apply/wrong_change_req.vue') },
      { meta: { smenu: 'apply' }, path: 'apply/ch_owner'          ,  component: () => import(/* webpackChunkName:"apply" */ './pages/apply/ch_owner.vue') },
      { meta: { smenu: 'apply' }, path: 'apply/ch_online'         ,  component: () => import(/* webpackChunkName:"apply" */ './pages/apply/ch_online.vue') },
      { meta: { smenu: 'apply' }, path: 'apply/stat_list'         ,  component: () => import(/* webpackChunkName:"apply" */ './pages/apply/stat_list.vue') },
      { meta: { smenu: 'apply' }, path: 'apply/return_req_req'    ,  component: () => import(/* webpackChunkName:"apply" */ './pages/apply/return_req_req.vue') },

      // 수임사건 내역조회
      { meta: { smenu: 'report' }, path: 'report/report_viacnt'    ,  component: () => import(/* webpackChunkName:"report" */ './pages/report/report_viacnt.vue') },
      { meta: { smenu: 'report' }, path: 'report/report_viadetail' ,  component: () => import(/* webpackChunkName:"report" */ './pages/report/report_viadetail.vue') },
      { meta: { smenu: 'report' }, path: 'report/report_viacancel' ,  component: () => import(/* webpackChunkName:"report" */ './pages/report/report_viacancel.vue') },

      // 증표구입
      { meta: { smenu: 'buy'   }, path: 'buy/buy_form'             ,  component: () => import(/* webpackChunkName:"buy" */ './pages/buy/buy_form.vue') },
      { meta: { smenu: 'buy'   }, path: 'buy/buy_ok'               ,  component: () => import(/* webpackChunkName:"buy" */ './pages/buy/buy_ok.vue') },
      { meta: { smenu: 'buy'   }, path: 'buy/buy_list'             ,  component: () => import(/* webpackChunkName:"buy" */ './pages/buy/buy_list.vue') },
      { meta: { smenu: 'buy'   }, path: 'buy/buy_receipt'          ,  component: () => import(/* webpackChunkName:"buy" */ './pages/buy/buy_receipt.vue') },
      { meta: { smenu: 'buy'   }, path: 'buy/buy_receipt_list'     ,  component: () => import(/* webpackChunkName:"buy" */ './pages/buy/buy_receipt_list.vue') },

      // 마이페이지
      { meta: { smenu: 'mypage'  }, path: 'mypage/qna'            ,  component: () => import(/* webpackChunkName:"mypage"    */ './pages/mypage/qna.vue') },
      { meta: { smenu: 'mypage'  }, path: 'mypage/qna_form'       ,  component: () => import(/* webpackChunkName:"mypage"    */ './pages/mypage/qna_form.vue') },
      { meta: { smenu: 'mypage'  }, path: 'mypage/qna_view'       ,  component: () => import(/* webpackChunkName:"mypage"    */ './pages/mypage/qna_view.vue') },
      { meta: { smenu: 'mypage'  }, path: 'mypage/setting_master' ,  component: () => import(/* webpackChunkName:"mypage"    */ './pages/mypage/setting_master.vue') },
      { meta: { smenu: 'mypage'  }, path: 'mypage/remote'         ,  component: () => import(/* webpackChunkName:"mypage"    */ './pages/mypage/remote.vue') },
      { meta: { smenu: 'mypage'  }, path: 'mypage/change_pw'      ,  component: () => import(/* webpackChunkName:"mypage"    */ './pages/mypage/change_pw.vue') },
//      { meta: { smenu: 'mypage'  }, path: 'mypage/myreqlist'      ,  component: () => import(/* webpackChunkName:"mypage"    */ './pages/mypage/myreqlist.vue') },
      { meta: { smenu: 'mypage'  }, path: 'mypage/myreqlist'      ,  component: () => import(/* webpackChunkName:"apply" */ './pages/apply/stat_list.vue') },


      // 샘플
      { meta: { smenu: 'sample'   }, path: 'sample/중요변수들'        ,  component: () => import(/* webpackChunkName:"sample" */ './pages/sample/중요변수들.vue') },
      { meta: { smenu: 'sample'   }, path: 'sample/devMemo'           ,  component: () => import(/* webpackChunkName:"sample" */ './pages/sample/devMemo.vue') },
      { meta: { smenu: 'sample'   }, path: 'sample/proc_list'         ,  component: () => import(/* webpackChunkName:"sample" */ './pages/sample/proc_list.vue') },
      { meta: { smenu: 'sample'   }, path: 'sample/proc_list_page'    ,  component: () => import(/* webpackChunkName:"sample" */ './pages/sample/proc_list_page.vue') },
      { meta: { smenu: 'sample'   }, path: 'sample/w_list_page'       ,  component: () => import(/* webpackChunkName:"sample" */ './pages/sample/w_list_page.vue') },
      { meta: { smenu: 'sample'   }, path: 'sample/s-table3'          ,  component: () => import(/* webpackChunkName:"sample" */ './pages/sample/s-table3.vue') },
      { meta: { smenu: 'sample'   }, path: 'sample/confirm_alert'     ,  component: () => import(/* webpackChunkName:"sample" */ './pages/sample/confirm_alert.vue') },
      { meta: { smenu: 'sample'   }, path: 'sample/fileattach'        ,  component: () => import(/* webpackChunkName:"sample" */ './pages/sample/fileattach.vue') },
      { meta: { smenu: 'sample'   }, path: 'sample/fileattach2'       ,  component: () => import(/* webpackChunkName:"sample" */ './pages/sample/fileattach2.vue') },
      { meta: { smenu: 'sample'   }, path: 'sample/회원선택'          ,  component: () => import(/* webpackChunkName:"sample" */ './pages/sample/회원선택.vue') },
      { meta: { smenu: 'sample'   }, path: 'sample/레포트'            ,  component: () => import(/* webpackChunkName:"sample" */ './pages/sample/레포트.vue') },
    ]
  },
  // {
  //   path: '*',
  //   component: () => import(/* webpackChunkName:"common" */ './pages/NotFound'),
  //   meta: { noAuth: true }
  // }
  {
    path: '*',
    component: LayoutMain,
    children: [
      { path: '', component: () => import(/* webpackChunkName:"common" */ './pages/NotFound'), meta: { noAuth: true } },
    ]
  }
]

export default routes